import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { TaskState } from '@interfaces/task/task.state';
import { Task } from '@interfaces/task/task';
import { TaskStatus } from '../enums/task-status';
import { PageInfo } from '@interfaces/page-info/page-info';

const createPageInfo = (): PageInfo => ({
  page: 1,
  totalPages: 1,
  hasNextPage: false,
  perPage: 20,
});

export const initialValue: TaskState = {
  tasks: [],
  taskPageInfo: createPageInfo(),
  assistreqPageInfo: createPageInfo(),
  nursePageInfo: createPageInfo(),
  alarmPageInfo: createPageInfo(),
};

export const TaskStore = signalStore(
  { providedIn: 'root' },
  withState(initialValue),
  withMethods(({ ...store }) => ({
    addTask(task: Task, status: TaskStatus) {
      task.status = status;
      task.activeResponder = { name: 'Pending' };
      let tasks: Task[] = [...store.tasks()];
      tasks.unshift(task);
      patchState(store, { tasks: tasks });
    },
    updateTasks(updatedTasks: Task[]) {
      patchState(store, { tasks: updatedTasks });
    },
    setTasks(tasks: Task[], pageInfo: PageInfo) {
      patchState(store, { tasks, taskPageInfo: pageInfo });
    },
    addTasks(tasks: Task[], pageInfo?: PageInfo, isTask: boolean = true) {
      tasks = tasks.map((task) => {
        task.isTask = isTask;
        return task;
      });
      patchState(store, {
        tasks: [...store.tasks(), ...tasks],
        taskPageInfo: pageInfo,
      });
    },
    addAssistreqTasks(tasks: Task[], pageInfo?: PageInfo) {
      patchState(store, {
        tasks: [...store.tasks(), ...tasks],
        assistreqPageInfo: pageInfo,
      });
    },
  })),
);
